import {tagEquals, TagModel} from './BaseTagModel';

/**
 * Used for Geo-restrictions for stories
 */
export const RestrictionTagModel = TagModel.extend({
    idAttribute: 'uuid',
    blacklist: ['included', 'order'],
    defaults: () => ({
        included: true,
        userGenerated: false,
        weight: 1,
    }),
    equals(tag) {
        return tagEquals(this, tag);
    },
});

RestrictionTagModel.of = (...args) => new RestrictionTagModel(...args);

export default RestrictionTagModel;